// firebase.js (modular - v9+)
// Initializes Firebase and exports commonly used services as named exports.

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
  /* const firebaseConfig = {
  apiKey: "AIzaSyANBJnoUTbbdmzvPw_itb-1-djocuUgJIs",
  authDomain: "shago-web.firebaseapp.com",
  databaseURL: "https://shago-web-default-rtdb.firebaseio.com",
  projectId: "shago-web",
  storageBucket: "shago-web.firebasestorage.app",
  messagingSenderId: "551832020206",
  appId: "1:551832020206:web:118e4475fdfc1594cd3fff",
  measurementId: "G-ZX4KDSRR63"
} ;*/
  const firebaseConfig = {
  apiKey: "AIzaSyBPUB-qt78Yc18HK9yDXgY3qTUJ2eJ1DIw",
  authDomain: "hollowpad-ai.firebaseapp.com",
  databaseURL: "https://hollowpad-ai-default-rtdb.firebaseio.com",
  projectId: "hollowpad-ai",
  storageBucket: "hollowpad-ai.firebasestorage.app",
  messagingSenderId: "816976736551",
  appId: "1:816976736551:web:5afb84e0a84426fa237902",
  measurementId: "G-6QER776PJ4"
};

// Initialize app (avoid double initialization)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize services
// Analytics can throw or be unsupported in some environments (SSR, Node) — guard it.
let analytics = null;
try {
  // Only run analytics in browser-like environments
  if (typeof window !== "undefined") {
    analytics = getAnalytics(app);
  }
} catch (err) {
  // Analytics is optional — failure is not fatal
  // console.warn("Firebase analytics not initialized:", err);
  analytics = null;
}

// Export named services
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);
const db = getDatabase(app);
const functions = getFunctions(app);

export { app as default, app, auth, firestore, storage, db as realtimeDb, functions, analytics };
